import { render, staticRenderFns } from "./SearchCards.vue?vue&type=template&id=c7ca1b3a&"
import script from "./SearchCards.vue?vue&type=script&lang=js&"
export * from "./SearchCards.vue?vue&type=script&lang=js&"
import style0 from "./SearchCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports